import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class EndGame extends BaseScene {
    private historyText?: Phaser.GameObjects.Text;

    constructor() {
        super({key: 'EndGame'});
    }

    public init() {
        super.init();
    }

    public create() {
        super.create();

        // BG
        const bg = this.add.image(this.width / 2, this.height / 2, 'castle').setOrigin(.5);
        this.forceSpriteNotScaleY(bg);
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.3);
        
        // Music
        this.getBootloaderScene().soundManager.playEndgameMusic(); 

        // Text
        this.historyText = this.add.text(this.width / 2, 1900, translate.key('end_game_text'))
            .setOrigin(0.5)
            .setWordWrapWidth(480)
            .setStyle({ 
                fontFamily: 'arial',
                fontSize: 28,
                color: '#FFFFFF',
                align: 'center',
            })
            .setStroke('#057d98', 5)
            .setShadow(0, 0, '#777', 5, true, false);

        // Button
        new ButtonSprite(this, this.width - 80, this.height - 80, 'button_next', 2, () => this.extiToMenu()).setScale(1);

    }

    private extiToMenu() {
        this.getBootloaderScene().launchScene('MainMenu');
    }

    public update() {

        if(this.historyText) {
            this.historyText.y = this.historyText.y-0.7;
        }

    }
}